import { render, staticRenderFns } from "./HomeBlockJoinplatform.vue?vue&type=template&id=32501435&scoped=true"
import script from "./HomeBlockJoinplatform.vue?vue&type=script&lang=js"
export * from "./HomeBlockJoinplatform.vue?vue&type=script&lang=js"
import style0 from "./HomeBlockJoinplatform.vue?vue&type=style&index=0&id=32501435&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32501435",
  null
  
)

export default component.exports